// PDP-specific bundle
// Dependencies
import { _ } from './utils'
import ColorCheck from './modules/color-check'
import CountProducts from './modules/count-products'
import Heart from './modules/heart'
import LazyLoad from './modules/lazy-load'
import smoothScroll from './modules/smooth-scroll'
import Tooltip from './modules/tooltip'
import Video from './modules/video'
import ZoomImage from './modules/zoom-image'
import { NumberControl } from './modules/number-control'
import PocherStickyAddToCart from './modules/pocher-sticky-add-to-cart'
import StockAlertToggle from './modules/stock-alert-toggle'
import { productViewTracking } from './tracking'
import AntavoPointsLoader from '@/javascript/modules/antavo-points-loader'
import SearchModal from './modules/search-modal'

window.dataLayer = window.dataLayer || []

_('color-check')
    .nodes()
    .forEach((el) => new ColorCheck(el))
_('count-products', 'element')
    .nodes()
    .forEach((el) => new CountProducts(el))
_('heart')
    .nodes()
    .forEach((el) => new Heart(el))
_('image', 'lazyload')
    .nodes()
    .forEach((el) => new LazyLoad(el))
_('product-view-tracking', 'element')
    .nodes()
    .forEach((el) => productViewTracking(el))
_('smooth-scroll')
    .nodes()
    .forEach((el) => smoothScroll(el))
_('tooltip', 'element')
    .nodes()
    .forEach((el) => new Tooltip(el))
_('video', 'element')
    .nodes()
    .forEach((el) => new Video(el))
_('zoom-image')
    .nodes()
    .forEach((el) => new ZoomImage(el))
_('number-control')
    .nodes()
    .forEach((el) => new NumberControl(el))
_('stock-alert-toggle', 'element')
    .nodes()
    .forEach((el) => new StockAlertToggle(el))
_('pocher-sticky-add-to-cart')
    .nodes()
    .forEach((el) => new PocherStickyAddToCart(el))

new AntavoPointsLoader()

const siteSearchModal = document.querySelector('[data-element="site-search"].site-search')
if (siteSearchModal) {
    new SearchModal(siteSearchModal)
}
